import { actions } from './Reducer';

export const getMyArtisanPublicInquiryAction = (payload) => ({
  type: actions.GET_MY_ARTISAN_PUBLIC_INQUIREY,
  payload,
});

export const getMyArtisanPublicInquirySuccessAction = (publicInquiry) => ({
  type: actions.GET_MY_ARTISAN_PUBLIC_INQUIREY_SUCCESS,
  payload: publicInquiry,
});

export const getMyArtisanPublicInquiriesAction = (body) => ({
  type: actions.GET_MY_ARTISAN_PUBLIC_INQUIRIES,
  payload: body,
});

export const getMyArtisanPublicInquiriesSuccessAction = (inquiries) => ({
  type: actions.GET_MY_ARTISAN_PUBLIC_INQUIRIES_SUCCESS,
  payload: inquiries,
});

export const filterMyArtisanPublicInquiriesAction = (body) => ({
  type: actions.FITLER_MY_ARTISAN_PUBLIC_INQUIRIES,
  payload: body,
});

export const filterMyArtisanPublicInquiriesSuccessAction = (inquiries) => ({
  type: actions.FITLER_MY_ARTISAN_PUBLIC_INQUIRIES_SUCCESS,
  payload: inquiries,
});

export const setMyArtisanPublicInquiryIsLoading = (isLoading) => ({
  type: actions.MY_ARTISAN_PUBLIC_INQUIREY_IS_LOADING,
  payload: isLoading,
});

export const getMyPublicArtisanProposalsAction = (body) => ({
  type: actions.GET_MY_ARTISAN_PUBLIC_PROPOSALS,
  payload: body,
});

export const getMyPublicArtisanProposalsSuccessAction = (proposals) => ({
  type: actions.GET_MY_ARTISAN_PUBLIC_PROPOSALS_SUCCESS,
  payload: proposals,
});

export const getMyPublicArtisanProposalAction = (body) => ({
  type: actions.GET_MY_ARTSAN_PUBLIC_PROPOSAL,
  payload: body,
});

export const getMyPublicArtisanProposalSuccessAction = (proposal) => ({
  type: actions.GET_MY_ARTSAN_PUBLIC_PROPOSAL_SUCCESS,
  payload: proposal,
});

export const addMyPublicArtisanProposalAction = (body, trusted) => ({
  type: actions.ADD_PUBLIC_ARTISAN_PROPOSAL,
  payload: body,
  trusted,
});

export const addMyPublicArtisanProposalSuccessActon = (proposal) => ({
  type: actions.ADD_PUBLIC_ARTISAN_PROPOSAL_SUCCESS,
  payload: proposal,
});

export const editMyPublicArtisanProposalAction = (body, trusted) => ({
  type: actions.EDIT_PUBLIC_ARTISAN_PROPOSAL,
  payload: body,
  trusted
});

export const editMyPublicArtisanProposalSuccessAction = (proposal) => ({
  type: actions.EDIT_PUBLIC_ARTISAN_PROPOSAL_SUCCESS,
  payload: proposal,
});

export const deleteMyPublicArtisanProposalAction = (body) => ({
  type: actions.DELETE_PUBLIC_ARTISAN_PROPOSAL,
  payload: body,
});

export const deleteMyPublicArtisanProposalSuccessAction = (id) => ({
  type: actions.DELETE_PUBLIC_ARTISAN_PROPOSAL_SUCCESS,
  payload: id,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_MY_ARTISAN_PUBLIC_INQUIREY_SEARCH,
  payload: value,
});

export const setMyArtisanPublicInquiriesCountAction = (count) => ({
  type: actions.SET_MY_ARTISAN_PUBLIC_INQUIREY_COUNT,
  payload: count,
});
